export interface CommitToStoresAndCompletePurchaseLogDto {
	isMissingItems: boolean;
	palletLineItemsToCommit: string;
	purchaseLogId: number;
}

export class CommitToStoresAndCompletePurchaseLogDto implements CommitToStoresAndCompletePurchaseLogDto {
	constructor(data?: Partial<CommitToStoresAndCompletePurchaseLogDto>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}